//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../no/SectionList.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../no/ObjectList.js";
let d=[[[0,"CutDir",0,"CAM.GuidingCurvesCutDir",0],[0,"CutOrder",0,"CAM.GuidedCurveCutOrder",0],[0,"CutSide",0,"CAM.CutSideBuilder",0],[0,"ExtendGuideCurve",1,0],[1,"FromCurveList",0,"SectionList",0],[0,"GcCutPattern",0,"CAM.CutPatternBuilder",0],[0,"MaximumGapLength",1,0],[0,"PatternType",0,"CAM.PatternTypeBuilder",0],[0,"Smoothing",1,0],[1,"StepoverBuilder",0,"CAM.StepoverBuilder",0],[0,"ToolPosition",0,"CAM.DmToolPosition",0],[0,"UseFaceNormal",1,0]],[[[],"SelectCurveAutomatically",{},0,0],[["sectionTag","num","bridgeCurves"],"ValidateCurves",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.CAM.GuidedCurveBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GuidedCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GuidedCurveBuilder.GcCutPatternTypes = Object.freeze({
    "ParallelLines" : "ParallelLines"});

export default SPLM;